// components
import SvgIconStyle from "../../../components/SvgIconStyle";
import Iconify from "../../../components/Iconify";
// 
import { useTranslation } from "react-i18next";

// ----------------------------------------------------------------------

const getIcon = (name) => (
  <SvgIconStyle
    src={`/assets/icons/navbar/${name}.svg`}
    sx={{ width: 1, height: 1 }}
  />
);

const ICONS = {
  user: getIcon("ic_user"),
  ecommerce: getIcon("ic_ecommerce"),
  analytics: getIcon("ic_analytics"),
  dashboard: getIcon("ic_dashboard"),
  newProject: getIcon("ic_kanban"),
};

export default function NavConfig(plannerLink) {
  const { t, i18n } = useTranslation();

  return [
    // GENERAL
    // ----------------------------------------------------------------------
    {
      subheader: t("navbars.left.instruments.label"),
      items: [
        { title: t("navbars.left.instruments.items.planner"), path: plannerLink, icon: ICONS.dashboard },
        { title: t("navbars.left.instruments.items.quotations"), path: "/dashboard/quotations", icon: ICONS.ecommerce },
        { title: t("navbars.left.instruments.items.new_project"), path: "/dashboard/new", icon: <Iconify icon={`material-symbols:library-add`} width={28} height={28} /> },
        //  { title: 'Two', path: '/dashboard/two', icon: ICONS.ecommerce },
        //  { title: 'Three', path: '/dashboard/three', icon: ICONS.analytics },
      ],
    },
  
    // MANAGEMENT
    // ----------------------------------------------------------------------
    // {
    //   subheader: "Gestione",
    //   items: [
    //     { title: "Listino", path: "/dashboard/user/four", icon: ICONS.ecommerce },
    //     { title: "Utenti", path: "/dashboard/user/five", icon: ICONS.user },
    //     {
    //       title: "Preventivi",
    //       path: "/dashboard/user/six",
    //       icon: ICONS.analytics,
    //     },
    //   ],
    // },
  ];
}
